export class RDListElement {

  public color = 'gold';
  public title = 'title';
  public author = 'me';
  public file = null;
  public icon = 'far fa-file';

  constructor() { }

}
